/**
 * AntragStatusBadge - the Antrag status chip (Tab 5a, P2 Slice 13). One Badge tone per status; the
 * label is the shared APPLICATION_STATUS_LABELS entry. null = «Kein Antrag». An overdue signature
 * appends a danger « - ueberfaellig» hint.
 */

import { Badge } from '../../components/ui/Badge';
import type { BadgeVariant } from '../../components/ui/Badge';
import { APPLICATION_STATUS_LABELS } from '@brokly/shared';
import type { ApplicationStatus } from '@brokly/shared';

const STATUS_TONE: Record<ApplicationStatus, BadgeVariant> = {
  vorbereitet: 'info',
  zur_unterschrift_versendet: 'warning',
  unterschrieben_eingegangen: 'success',
  eingereicht: 'success',
  bedingungen_geaendert: 'info',
  angenommen: 'info',
  abgelehnt: 'info',
  deckungsbestaetigt: 'info',
  police_erhalten: 'info',
  geprueft: 'info',
  abgeschlossen: 'info',
  verworfen: 'outline',
};

export function AntragStatusBadge({ status, ueberfaellig }: { status: ApplicationStatus | null; ueberfaellig?: boolean }) {
  if (status === null) {
    return (
      <Badge variant="neutral" data-testid="antrag-status-badge">
        Kein Antrag
      </Badge>
    );
  }
  if (status === 'zur_unterschrift_versendet' && ueberfaellig) {
    return (
      <Badge variant="danger" data-testid="antrag-status-badge">
        {APPLICATION_STATUS_LABELS[status]} - ueberfaellig
      </Badge>
    );
  }
  return (
    <Badge variant={STATUS_TONE[status]} data-testid="antrag-status-badge">
      {APPLICATION_STATUS_LABELS[status]}
    </Badge>
  );
}
